module.exports = __webpack_public_path__ + "img/img36_5.9d9ec170.svg";